import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { formValueSelector } from 'redux-form';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import { LoadersNames } from '../../ui/ui.constants';
import api from '../../../core/api';
import { Forms } from '../../form/form.selector';
import { appPremixesSelector, selectedSelector } from '../../selectors';
import { previewCreatePremix, sendPremixPayload } from './appPremixes.actions';
import { TargetWeights } from '../recipes/appRecipes.types';

export function* previewCreatePremixSaga(action: any) {
  yield put(showLoader(LoadersNames.previewPremix));
  const { description, displayName, density, adjOnDM, notInUse, autoAdjWater, targetDMPerc } = yield select(
    formValueSelector(Forms.premixCreationForm),
    'description',
    'displayName',
    'density',
    'adjOnDM',
    'notInUse',
    'autoAdjWater',
    'targetDMPerc',
  );

  const targetWeightType = yield select(formValueSelector(Forms.premixIngredientsForm), 'targetWeightType');

  const premixPayload = yield select(appPremixesSelector.getPremixPayload);

  try {
    const ration = {
      displayName: displayName || ' ',
      description: description || ' ',
      density: density || 100,
      adjOnDM,
      notInUse,
      autoAdjWater,
      days: [0],
      percEntryMethod: targetWeightType === TargetWeights.DRY ? 1 : 2,
      targetDMPerc: autoAdjWater ? Number(targetDMPerc) : 0,
      premix: true,
      ...premixPayload,
    };

    const isEditMode = yield select(appPremixesSelector.getIsEditMode);
    let result;
    if (isEditMode) {
      const premixId = yield select(selectedSelector.getSelectedPremixId);
      result = yield call(api.premixes.simulateEditPremix, premixId, ration);
    } else {
      result = yield call(api.premixes.simulateCreatePremix, ration);
    }
    yield put(
      previewCreatePremix.done({
        params: {},
        result,
      }),
    );
  } catch (err) {
    if (err.status === 409) {
      yield put(previewCreatePremix.done({ params: {}, result: err.data }));
    } else {
      yield put(
        previewCreatePremix.failed({
          params: {},
          error: {},
        }),
      );
    }
  }
  yield put(hideLoader(LoadersNames.previewPremix));
}

export function* watchAppPremixesSaga() {
  yield all([yield takeLatest(sendPremixPayload.type, previewCreatePremixSaga)]);
}
